import {
  INumberQueryOptions,
  INumberSlice,
} from "@/redux/slices/numbers/types";

const changeNumberOption = (
  state: INumberSlice,
  {
    payload,
  }: {
    payload: {
      key: keyof INumberQueryOptions;
      value: string;
    };
  }
) => {
  state.options[payload.key as any] = payload.value;
};

const changeNumberCategory = (
  state: INumberSlice,
  {
    payload,
  }: {
    payload: "all" | "standard" | "premium";
  }
) => {
  state.options.numberCategory = payload;
  switch (payload) {
    case "standard":
      state.numbers.premium = {
        loading: false,
        page: 0,
        total_count: 0,
        total_pages: 0,
        numbers: [],
      };
      break;
    case "premium":
      state.numbers.standard = {
        loading: false,
        page: 0,
        total_count: 0,
        total_pages: 0,
        numbers: [],
      };
      break;
  }
};

export default {
  changeNumberOption,
  changeNumberCategory,
};
